import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";
import "./DateContainer.css";
import { observer } from "mobx-react-lite";
import { useCourtBookingStore } from "../../stores/StoreContext";
import { DateInfo } from "../../stores/CourtBookingStore";

type props = {
  dateInfo: DateInfo;
};

export const DateContainer: React.FC<props> = observer(({ dateInfo }) => {
  const courtBookingStore = useCourtBookingStore();

  return (
    <div
      style={{
        minWidth: 56,
        height: 64,
        borderRadius: 16,
        backgroundColor:
          courtBookingStore.selectedDate === dateInfo
            ? Colors.green
            : Colors.lightGreyBackground,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
      onClick={() => {
        courtBookingStore.setSelectedDate(dateInfo);
      }}>
      <div>
        <TCText
          style={{
            color:
              courtBookingStore.selectedDate === dateInfo
                ? "white"
                : Colors.grey,
            textAlign: "center",
          }}
          className="date-container-day"
          value={dateInfo.day}
        />
        <TCText
          style={{
            color:
              courtBookingStore.selectedDate === dateInfo
                ? "white"
                : Colors.grey,
            textAlign: "center",
          }}
          className="date-container-date"
          value={dateInfo.date}
        />
        <TCText
          style={{
            color:
              courtBookingStore.selectedDate === dateInfo
                ? "white"
                : Colors.grey,
            textAlign: "center",
          }}
          className="date-container-month"
          value={dateInfo.month}
        />
      </div>
    </div>
  );
});
